var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":"请选择角色","clearable":_vm.clearable,"idKey":"RoleId","labelKey":"RoleName","get-data-func":_vm.getDataFunc},on:{"input":function (v){ return _vm.$emit('input',v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }